export default "__VITE_ASSET__DFGTB6j5__"